















import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'EyeTraitPreview',
  filters: {
    convertToHex(value: number) {
      return `#${value.toString(16)}`;
    },
  },
})
export default class EyeTraitPreview extends Vue {
  @Prop(Number) readonly pupilTone: number | undefined;
  @Prop(Boolean) readonly showIris: boolean | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;
}
